export enum LEAGUE_SELECTION_STATUS {
  NORMAL = 'normal',
  PLACEHOLDER = 'placeholder',
  PLACEHOLDER_TOTAL = 'placeholderTotal',
  DISABLED = 'disabled',
  TOTAL = 'total',
}
